"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomUtil = exports.changeLanguage = void 0;
const types_1 = require("../../types");
const LOCALE_LANGUAGE_CODE_MAP = {
    [types_1.Locale.ES_US]: 'es',
    [types_1.Locale.EN_US]: 'en'
};
const getElement = (element) => {
    return document.querySelector(element);
};
const changeTitle = (value) => {
    const titleEl = getTitle();
    if (titleEl) {
        titleEl.innerHTML = value;
    }
};
const getTitle = () => {
    return getElement('title');
};
const changeFavicon = (src) => {
    const faviconEl = getFavicon();
    if (faviconEl) {
        faviconEl.href = src;
    }
};
const getFavicon = () => {
    return getElement("link[rel='shortcut icon']");
};
const changeDescription = (value) => {
    const descriptionEl = getDescription();
    if (descriptionEl) {
        descriptionEl.setAttribute('content', value);
    }
};
const getDescription = () => {
    return getElement("meta[name='description']");
};
const getHtml = () => {
    return getElement('html');
};
const changeLanguage = (value) => {
    const htmlEl = getHtml();
    if (htmlEl) {
        htmlEl.setAttribute('lang', LOCALE_LANGUAGE_CODE_MAP[value] || 'en');
    }
};
exports.changeLanguage = changeLanguage;
const createElement = (el, options) => {
    const element = document.createElement(el);
    if (options) {
        if (options === null || options === void 0 ? void 0 : options.class)
            element.className = options.class;
        if (options.ariaLabel)
            element.setAttribute('aria-label', options.ariaLabel);
        const { class: _ } = options, opts = __rest(options, ["class"]);
        Object.entries(opts).forEach(([key, val]) => (element[key] = val));
    }
    return element;
};
const setManyAttributes = (elements, opts) => {
    elements.forEach(el => Object.entries(opts).forEach(([key, val]) => (el[key] = val)));
};
exports.DomUtil = {
    getElement,
    changeTitle,
    getTitle,
    changeFavicon,
    getFavicon,
    changeDescription,
    getDescription,
    changeLanguage: exports.changeLanguage,
    getHtml,
    createElement,
    setManyAttributes
};
exports.default = exports.DomUtil;
